"use client";

import { useEffect } from "react";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		console.error("Global error:", error);
	}, [error]);

	return (
		<html>
			<body>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						minHeight: "100vh",
						padding: "20px",
						backgroundColor: "#000",
						color: "#fff",
					}}
				>
					<div
						style={{
							maxWidth: "600px",
							textAlign: "center",
						}}
					>
						<h1 style={{ fontSize: "32px", marginBottom: "16px" }}>
							Something went wrong!
						</h1>
						<p style={{ marginBottom: "20px", color: "#999" }}>
							Something went wrong. Please try again.
						</p>
						{process.env.NEXT_PUBLIC_ENV === "local" && (
							<details
								style={{
									marginTop: "20px",
									textAlign: "left",
									backgroundColor: "#222",
									padding: "16px",
									borderRadius: "8px",
									overflow: "auto",
									maxHeight: "400px",
								}}
							>
								<summary style={{ cursor: "pointer", marginBottom: "10px" }}>
									Error Details (Development Only)
								</summary>
								<pre
									style={{
										fontSize: "12px",
										whiteSpace: "pre-wrap",
										wordBreak: "break-word",
									}}
								>
									{error.message}
									{"\n\n"}
									{error.stack}
									{error.digest && `\n\nDigest: ${error.digest}`}
								</pre>
							</details>
						)}
						<div style={{ marginTop: "24px" }}>
							<button
								onClick={() => reset()}
								style={{
									marginRight: "12px",
									padding: "12px 24px",
									backgroundColor: "#fff",
									color: "#000",
									border: "none",
									borderRadius: "8px",
									cursor: "pointer",
									fontSize: "16px",
								}}
							>
								Try Again
							</button>
							<button
								onClick={() => (window.location.href = "/")}
								style={{
									padding: "12px 24px",
									backgroundColor: "#333",
									color: "#fff",
									border: "1px solid #555",
									borderRadius: "8px",
									cursor: "pointer",
									fontSize: "16px",
								}}
							>
								Go Home
							</button>
						</div>
					</div>
				</div>
			</body>
		</html>
	);
}
